import React, { useState } from "react";
import { IonContent, IonModal } from "@ionic/react";

type Props = {
  disclaimerText: string;
};
const WellbeingDisclaimerModal: React.FC<Props> = (props) => {
  const [visible, setVisible] = useState<boolean>(true);

  return (
    <IonModal
      id="wellbeing-disclaimer-modal"
      isOpen={visible}
      backdropDismiss={true}
      canDismiss={true}
      onDidDismiss={() => setVisible(false)}
      className="fullscreen"
    >
      <IonContent>
        <div className="flex flex-col justify-between h-full">
          <div className="mt-[16px] px-[16px]">
            <div className="text-[17px] font-bold leading-[1.41] tracking-default text-center text-grey-90">
              {"Disclaimer"}
            </div>
            <div className="mt-[4px] text-[15px] leading-[1.33] tracking-[-0.3px] text-center text-grey-90">
              {props.disclaimerText}
            </div>
          </div>
          <div className="flex flex-col">
            <div className="border-t border-t-grey-30">
              <button
                className="h-[48px] w-full"
                onClick={() => setVisible(false)}
              >
                <div className="text-[16px] font-semibold leading-default tracking-default text-center text-cta-blue">
                  {"Dismiss"}
                </div>
              </button>
            </div>
          </div>
        </div>
      </IonContent>
    </IonModal>
  );
};

export default WellbeingDisclaimerModal;
